import * as React from "react";
const SvgTourClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M.452 2.635A1.543 1.543 0 1 1 2.635.452l10.913 10.913a1.543 1.543 0 0 1-2.183 2.183z"
    />
    <path
      fill="#fff"
      d="M2.635 13.548a1.543 1.543 0 0 1-2.183-2.183L11.365.452a1.543 1.543 0 0 1 2.183 2.183z"
    />
  </svg>
);
export default SvgTourClose;
